import React, { useEffect, useState } from 'react';
import ContractReportTemplate from '../../_components/templates/ContractReportTemplate';
import TabSelection from '../../_components/molecules/TabSelection';
import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  CardComponent,
  ProgressComparison,
  RegulationsCard,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import contractAIQConstants from '../../core-utils/messages/ContractAIQConstants';
// import ClauseInfo from '../../_components/organisms/ClauseInfo';
import properties from '../../core-utils/properties';
import axios from 'axios';
import { useStores } from '../../stores';
import {
  TitleAndSubTitle,
  getReportBreadcrumbList,
  getSOBReportBreadcrumbList,
} from '../../core-utils/helper-utils/contractAIQHelper';
import Loader from '../../_components/molecules/Loader';
// import GifWithLabels from '@HomaHealth/ui-component-library/lib/_patient-access-components/molecules/GIFWithLabels';
// import Grading from '../../../public/Images/Grading.png';
import { handleDownloadReport } from '../../core-utils/helper-utils/contractReportHelper';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import Snackbar from '../../_components/atoms/Snackbar';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { PDF_WORKER_URL } from '../../core-utils/helper-utils/pdfWorker';

const InterContractReport = () => {
  //styles
  const useStyles = makeStyles()({
    tabContent: {
      paddingTop: '24px',
    },
    overviewTab: {
      display: 'flex',
      flexDirection: 'column',
      gap: '32px',
    },
  });

  //constants
  const { classes } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const {
    compareId,
    isContract,
    contractId,
    planDocId,
    reportName,
  }: any = location.state;
  const breadcrumbs = getReportBreadcrumbList(navigate, location?.state);
  const sobBreadcrumbs = getSOBReportBreadcrumbList(navigate, location?.state);
  const constants =
    contractAIQConstants.CONTRACT_REPORTS.COMPARISON_WITH_HEALTHCARE;
  const employerGroupStore = useStores().employerGroupStore;
  // const contractStore = useStores().contractAiqStore;

  //states
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [activeTab, setActiveTab] = useState<{ id: string; index?: number }>({
    id: 'summary',
    index: 0,
  });
  const [categories, setCategories] = useState<any>([]);
  const [binary, setBinary] = useState<any>();
  const [docLoading, setDocLoading] = useState<boolean>(true);
  const [selectedCategory, setSelectedCategory] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [loader] = useState<any>(<Loader />);
  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  //APIs
  const getInterContractReportData = () => {
    const url =
      properties.aiqBaseUrl +
      properties.contractBaseUrl +
      properties.interContractReport;
    axios
      .post(url, {
        eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
        agreement_ids: [isContract ? contractId : planDocId, compareId],
      })
      .then((response) => {
        const data = response?.data?.data?.data?.categories;
        setCategories(data);
        setLoading(false);
      })
      .catch((error) => {
        throw error;
      });
  };

  //functions
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const handleReportSummary = () => {
    setActiveTab({ id: 'summary', index: 0 });
  };

  const getReportName = () => {
    switch (reportName) {
      case 'Gap Analysis':
        return 'gapAnalysisReport';
      default:
        return 'interContractReport';
    }
  };

  const getType = () => {
    switch (reportName) {
      case 'Gap Analysis':
        return 'pd-stoploss';
      case 'Comparison with PBM Service Agreement':
        return 'spd-pbm';
      default:
        return 'spd-asa';
    }
  };

  const handleDownloadInterContractReport = () => {
    handleDownloadReport(
      getReportName(),
      employerGroupStore?.employerGroupResponseData?.employer_group_name[0],
      isContract ? contractId : planDocId,
      handleOpenSnackBar,
      employerGroupStore?.employerGroupResponseData?.eg_nid[0],
      compareId,
      isContract ? 'asa-stoploss' : getType(),
    );
  };

  //function to get content of report summary tabs based on tab index
  const getTabContent = () => {
    switch (selectedTabIndex) {
      case 0:
        return <OverviewTab />;
      default:
        return <></>;
    }
  };

  //function to get content on the right based on left tab selection
   
  const getActiveTabContent = () => {
    switch (activeTab.id) {
      case 'summary':
        return <ReportSummaryContent />;
      case 'selected-category':
        return <SelectedCategory />;
      default:
        return <></>;
    }
  };

  //function to get colors of categories
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'no-issues':
        return '#17A39C';
      case 'missing-lines':
        return '#D6545E';
      case 'conflicts':
        return '#E1A948';
      default:
        return '';
    }
  };

  const getPdf = async () => {
    const token = JSON.parse(localStorage.getItem('token-storage') as string)
      ?.access_token;

    await axios
      .post(
        properties.aiqBaseUrl + properties.downloadComplianceAssuranceReport,
        {
          contract_id: isContract ? contractId : planDocId,
          employer:
            employerGroupStore.employerGroupResponseData.employer_group_name[0],
          reportName: getReportName(),
          compare_agreement_id: compareId,
          eg_nid: employerGroupStore.employerGroupResponseData.eg_nid[0],
          type: isContract ? 'asa-stoploss' : getType(),
        },
        {
          headers: {
            Authorization: token,
          },
        },
      )
      .then((res) => {
        if (res) {
          const base64Data = res.data?.data;
          // setBinary(base64Data);
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length)
            .fill(0)
            .map((_, i) => byteCharacters.charCodeAt(i));
          const byteArray = new Uint8Array(byteNumbers);
          setBinary(byteArray);
          setDocLoading(false);
        }
      })
      .catch((error) => {
        handleOpenSnackBar(error.response?.data?.error, 'error', 5000);
      });
  };

  //useEffects
  useEffect(() => {
    getInterContractReportData();
  }, []);

  useEffect(() => {
    getPdf();
  }, []);

  //components
  //component for list of Categories on the left
  const Categories = () => {
    return (
      <Grid>
        {categories?.map((item: any, index: number) => {
          return (
            <RegulationsCard
              title={item?.category}
              description={''}
              count={item?.topics?.length}
              handleOnclick={() => {
                setActiveTab({
                  id: 'selected-category',
                  index: index + 1,
                });
                setSelectedCategory(item);
              }}
              isActive={activeTab.index === index + 1}
              barColor={getCategoryColor(item?.category)}
              tooltip={item?.description}
            />
          );
        })}
      </Grid>
    );
  };

  //component for report summary content
  const ReportSummaryContent = () => {
    return (
      <>
        <TabSelection
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={setSelectedTabIndex}
          tabList={constants.SUMMARY_TABS}
        />
        <Grid className={classes.tabContent}>{getTabContent()}</Grid>
      </>
    );
  };

  //components for repetitive Typography
  const getHeadingTypography = (label: string, margin?: string) => {
    return (
      <Typography
        fontSize="16px"
        fontType="semiBold"
        lineHeight="140%"
        textColor={patientAccessTheme.palette.text.highemphasis}
        margin={margin}
      >
        {label}
      </Typography>
    );
  };

  const getSubHeadingTypography = (label: string, bold?: boolean) => {
    return (
      <Typography
        fontSize="14px"
        fontType={bold ? 'semiBold' : 'regular'}
        lineHeight="24px"
        textColor={patientAccessTheme.palette.text.mediumemphasis}
        display="inline"
      >
        {label}
      </Typography>
    );
  };

  //component for no clause found
  // const NoClauseFound = (agreement: string) => {
  //   return (
  //     <GifWithLabels
  //       rootStyles={{ padding: '24px 0px' }}
  //       mainLabel={
  //         <Typography
  //           fontSize="14px"
  //           fontType="medium"
  //           lineHeight="24px"
  //           textColor={patientAccessTheme.palette.text.mediumemphasis}
  //           margin="-12px 0px 0px 0px"
  //         >
  //           No Clause Found
  //         </Typography>
  //       }
  //       subLabel={
  //         <Typography
  //           fontSize="12px"
  //           fontType="regular"
  //           lineHeight="16.8px"
  //           textColor={patientAccessTheme.palette.text.mediumemphasis}
  //         >
  //           Missing Extract in the {agreement}
  //         </Typography>
  //       }
  //       gifUrl={Grading}
  //     />
  //   );
  // };

  //component for overview tab content
  const OverviewTab = () => {
    const noConflictsTopics =
      categories.find((item: any) => item.category === 'no-issues')?.topics
        .length || 0;
    const missingClausesTopics =
      categories.find((item: any) => item.category === 'missing-lines')?.topics
        .length || 0;
    const conflictTopics =
      categories.find((item: any) => item.category === 'conflicts')?.topics
        .length || 0;

    const totalTopics =
      noConflictsTopics + missingClausesTopics + conflictTopics;

    const categoriesData = categories?.map((item: any) => ({
      name: item?.category,
      color: getCategoryColor(item?.category),
      value: item?.topics?.length,
    }));

    return (
      <Grid className={classes.overviewTab}>
        <Grid>
          {getHeadingTypography(constants.SUMMARY.TITLE, '0px 0px 12px 0px')}
          <Grid>
            {getSubHeadingTypography(
              constants.SUMMARY.SUBTITLE.PART1 + ` and , we analyzed a `,
            )}
            {getSubHeadingTypography(`total of ${totalTopics} topics.`, true)}
            {totalTopics !== 0 &&
              getSubHeadingTypography(constants.SUMMARY.SUBTITLE.PART2)}
            {noConflictsTopics !== 0 && (
              <>
                {getSubHeadingTypography(
                  `${noConflictsTopics} topics were found to have No Conflicts,`,
                  true,
                )}
                {getSubHeadingTypography(constants.SUMMARY.SUBTITLE.PART3)}
              </>
            )}
            {conflictTopics !== 0 && (
              <>
                {getSubHeadingTypography(
                  ` However, ${conflictTopics} topics showed Possible Misalignment,`,
                  true,
                )}
                {getSubHeadingTypography(constants.SUMMARY.SUBTITLE.PART4)}
              </>
            )}
            {missingClausesTopics !== 0 && (
              <>
                {getSubHeadingTypography(
                  `Additionally, ${missingClausesTopics} topics were identified as having Missing Clauses,`,
                  true,
                )}
                {getSubHeadingTypography(constants.SUMMARY.SUBTITLE.PART5)}
              </>
            )}
            {totalTopics !== 0 &&
              getSubHeadingTypography(constants.SUMMARY.SUBTITLE.PART6)}
          </Grid>
        </Grid>
        <Grid>
          <CardComponent
            title={'Topics'}
            padding="16px"
            body={<ProgressComparison categories={categoriesData} />}
          />
        </Grid>
        {categories?.map((category: any) => (
          <Grid key={category?.category}>
            {getHeadingTypography(category?.category, '0px 0px 11px 0px')}
            <Typography
              fontSize="14px"
              fontType={'regular'}
              lineHeight="24px"
              textColor={patientAccessTheme.palette.text.mediumemphasis}
              margin={'0px 0px 16px 0px'}
            >
              {category?.description}
            </Typography>
            {/* {ListOfCategoryTopics(category)} */}
          </Grid>
        ))}
      </Grid>
    );
  };

  //component for list of topics for a category
  // const ListOfCategoryTopics = (category: any) => {
  //   return (
  //     <Grid>
  //       {category?.topics?.length > 0 && (
  //         <>
  //           {category?.topics?.map((item: any) => {
  //             const currContractExtracts: string[] = [];
  //             const comparedContractExtracts: string[] = [];

  //             item?.check_off_list?.map((extract: any) => {
  //               const currExtract = extract[currContractId];
  //               const comparedExtract = extract[comparedSvcAgreeId];

  //               if (currExtract) {
  //                 currContractExtracts.push(currExtract);
  //               }
  //               if (comparedExtract) {
  //                 comparedContractExtracts.push(comparedExtract);
  //               }
  //             });

  //             const getMissingAnalysis = () => {
  //               return `The responsibility mentioned in the ${
  //                 currContractExtracts?.length !== 0
  //                   ? category?.contracts[currContractId]
  //                   : category?.contracts[comparedSvcAgreeId]
  //               } is missing from the ${
  //                 comparedContractExtracts?.length !== 0
  //                   ? category?.contracts[currContractId]
  //                   : category?.contracts[comparedSvcAgreeId]
  //               }`;
  //             };

  //             return (
  //               <Grid style={{ marginBottom: '12px' }}>
  //                 <ClauseInfo
  //                   title={item?.topic_name}
  //                   summaryTitle={'Aim of the topic'}
  //                   summaryDescription={item?.summary}
  //                   analysisTitle="Analysis of the topic"
  //                   analysisDescription={
  //                     item?.explanation
  //                       ? item?.explanation
  //                       : getMissingAnalysis()
  //                   }
  //                   extractsTitle={`Extracts from ${category?.contracts[currContractId]} contract`}
  //                   extracts={currContractExtracts}
  //                   extractsBody={NoClauseFound(
  //                     category?.contracts[currContractId],
  //                   )}
  //                   reasonsTitle={`Extracts from ${category?.contracts[comparedSvcAgreeId]} contract`}
  //                   reasons={comparedContractExtracts}
  //                   reasonsBody={NoClauseFound(
  //                     category?.contracts[comparedSvcAgreeId],
  //                   )}
  //                   type={'Met'}
  //                   hideChip
  //                 />
  //               </Grid>
  //             );
  //           })}
  //         </>
  //       )}
  //     </Grid>
  //   );
  // };

  //component for selected category
  const SelectedCategory = () => {
    return (
      <>
        <Grid style={{ marginBottom: '24px' }}>
          {TitleAndSubTitle(
            selectedCategory?.category,
            selectedCategory?.category_description,
          )}
        </Grid>
        {/* {ListOfCategoryTopics(selectedCategory)} */}
      </>
    );
  };

  return (
    <>
      {loading ? (
        loader
      ) : (
        <ContractReportTemplate
          breadcrumbsList={isContract ? breadcrumbs : sobBreadcrumbs}
          reportName={''}
          document={''}
          handleDocumentOnclick={() => {}}
          handleDownloadReport={handleDownloadInterContractReport}
          showDownloadReport={true}
          handleReportSummary={handleReportSummary}
          isReportSummaryActive={activeTab.id === 'summary'}
          leftContent={false && <Categories />}
          // rightContent={false && getActiveTabContent()}
          rightContent={
            docLoading
              ? loader
              : binary && (
                  <Worker workerUrl={PDF_WORKER_URL}>
                    <Grid container style={{ marginBottom: '29px' }}>
                      <Typography
                        fontSize="16px"
                        lineHeight="24px"
                        fontType="semiBold"
                        textColor={patientAccessTheme.palette.text.highemphasis}
                        margin="0px 0px 20px 0px"
                      >
                        {'Report PDF'}
                      </Typography>
                      <Viewer fileUrl={binary} />
                    </Grid>
                  </Worker>
                )
          }
        />
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
    </>
  );
};

export default InterContractReport;
